var _effectorFileName = "/builds/gmini/front-ui-kit/src/ResizableColumns/Panel/Panel.tsx";
import { Fade } from '@mui/material';
import { Box } from '../../Box';
import { IconButton } from '../../IconButton';
import { UnfoldLess, UnfoldMore } from '../../icons';
import { CollapsedBody, FolderTitle, PanelBody, PanelContent, PanelHeader, PanelTitle, SeparatorList } from './Panel.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Private component, do not use in your app!
 * Use `ResizablePanel` instead.
 */
export const Panel = ({
  expanded,
  children,
  title,
  header,
  footer,
  headerSecondary,
  showExpandButton,
  foldedTitle = title,
  body,
  bodyStyles,
  hideCssOnlyDN,
  noHeaderSeparator,
  hideCssOnlyVH,
  onClose,
  onOpen,
  ...domAttributes
}) => /*#__PURE__*/_jsxs(PanelBody, {
  expanded: expanded,
  ...domAttributes,
  bodyStyles: bodyStyles,
  "data-test-ui-type": "EditorSection",
  onClick: () => !expanded ? onOpen() : null,
  children: [(hideCssOnlyDN || hideCssOnlyVH || expanded) && /*#__PURE__*/_jsxs(PanelContent, {
    hideDN: Boolean(hideCssOnlyDN && !expanded),
    hideVH: Boolean(hideCssOnlyVH && !expanded),
    expanded: expanded,
    "data-test-ui-type": "ExpandedBody",
    children: [expanded && /*#__PURE__*/_jsxs(PanelHeader, {
      "data-test-ui-type": "Header",
      variant: "dense",
      noHeaderSeparator: noHeaderSeparator,
      children: [title && /*#__PURE__*/_jsx(PanelTitle, {
        "data-test-ui-type": "Text",
        children: title
      }), header, /*#__PURE__*/_jsxs(SeparatorList, {
        children: [headerSecondary, /*#__PURE__*/_jsx(Fade, {
          in: showExpandButton,
          unmountOnExit: true,
          children: /*#__PURE__*/_jsx(IconButton, {
            "data-test-ui-type": "closePanel",
            onClick: onClose,
            children: /*#__PURE__*/_jsx(UnfoldLess, {
              color: "rgba(53, 59, 96, 0.5)"
            })
          })
        })]
      })]
    }), body && body, /*#__PURE__*/_jsx(Box, {
      minWidth: "306px",
      position: "relative",
      flexGrow: 1,
      children: children
    }), footer && /*#__PURE__*/_jsx("div", {
      children: footer
    })]
  }), /*#__PURE__*/_jsxs(CollapsedBody, {
    hideDN: expanded,
    "data-test-ui-type": "FoldedBody",
    expanded: expanded,
    children: [/*#__PURE__*/_jsx(Box, {
      display: "flex",
      justifyContent: "center",
      mt: "5px",
      children: /*#__PURE__*/_jsx(IconButton, {
        "data-test-ui-type": "openPanel",
        children: /*#__PURE__*/_jsx(UnfoldMore, {
          color: "rgba(53, 59, 96, 0.5)"
        })
      })
    }), foldedTitle && /*#__PURE__*/_jsx(FolderTitle, {
      "data-test-id": "FoldedHeaderText",
      children: foldedTitle
    })]
  })]
});